import { render, staticRenderFns } from "./MedicationQuartiles.vue?vue&type=template&id=eb9dd236&"
import script from "./MedicationQuartiles.vue?vue&type=script&lang=js&"
export * from "./MedicationQuartiles.vue?vue&type=script&lang=js&"
import style0 from "./MedicationQuartiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
